import React from "react";
import { DataNotFound } from "../../../../Components/SharedComponent/ReviewSummarySectionNotFound/DataNotFound";
import DigitalWalletsOverview from "./DigitalWalletsOverview";
import CardNetworkAndBinInfo from "../CardNetworkAndBinInfoOverview";
import CardPrinterOverview from "../OptionalFeaturesOverview/CardPrinterOverview";
import ECommerceOverview from "./E-CommerceOverview";
import AdditionalNetworkServicesOverview from "./AdditionalNetworkServicesOverview";
import AccountUpdateServiceOverview from "./AccountUpdateServiceOverview";

const CardNetworkAndBinInformationOverview = ({ data }) => {
  if (!data) return <DataNotFound />;
  return (
    <React.Fragment>
      {/* <AdminWebsiteOverview data={data} /> */}
      <CardNetworkAndBinInfo data={data} />
      <CardPrinterOverview data={data} />
      <DigitalWalletsOverview data={data} />
      <ECommerceOverview data={data} />
      <AccountUpdateServiceOverview data={data} />
      <AdditionalNetworkServicesOverview data={data} />
    </React.Fragment>
  );
};

export default CardNetworkAndBinInformationOverview;
